import { TagInput } from './tag_input'

export class NewCampaignOne extends HTMLElement {
  constructor(is_admin, domain_id, defaults) {
    super();
    this._is_admin = is_admin;
    this.domain_id = domain_id;
    this.defaults = defaults.default_values;
    this.default_tags = defaults.tag_groups.map(tag => tag.tag_group_id);
  }

  async connectedCallback() {
    this.innerHTML = `
    <style>
      new-campaign-one .form-group {
        margin-bottom: 20px;
      }
      .form-group i {
        font-style: italic;
        font-weight: normal;
      }
      .campaign_team {
        padding:0px 15px;
      }
    </style>
    <div class="step-number-header">
      <div class="campaign-step-num campaign-step-active"><span>1</span></div>
      <h4>Basic Settings</h4>
    </div>
    <div class="step-container">
      
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-1"></div>
          <label>How many campaigns would you like to create?</label>
          <select class="form-control" id="campaign-count" data-cy="campaign-count">
          </select>
          <label>Name</label>&nbsp<span>(* for multiple campaigns this is an optional prefix)</span>
          <input type="text" class="form-control" id="campaign-name" data-cy="campaign-name" placeholder="e.g., google.com">
          
          <div class="tags-container"></div>
          <div class="row call-options">
            <div class="col-sm-6 col-xs-12">
            <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
            <label class="col-md-6 control-label" style="text-align:left">CallShield</label>
              <div class="col-md-6"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="call-shield-switch">
                  <span data-cy="call-shield-switch"></span>
                </label>
              </div>
          </div>
          <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
            <label class="col-md-6 control-label" style="text-align:left">LeadScore</label>
            <div class="col-md-6"  align="left">
              <label class="switch"><input type="checkbox" class="form-control switch" id="lead-score-switch" ${this.defaults.leadscore == 1 ? "checked" : ""}><span data-cy="lead-score-switch"></span></label>
            </div>
          </div>
          <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
            <label class="col-md-6 control-label" style="text-align:left">Call Recording
              <span>
                <span class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" data-html="true" 
                title="<p style='text-align:left'>Call Recording includes a Recording Disclaimer to announce this call is being recorded</p>"</span>
              </span>
            </label>
              <div class="col-md-6"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="call-rec-switch" ${this.defaults.call_recording == 1 ? "checked" : ""}>
                  <span data-cy="call-rec-switch"></span>
                </label>
              </div>
          </div>


          ${this._is_admin ? `
            <div class="dni-speech-transcription-enabled ${this.defaults.call_recording == 1 ? "" : "hidden"}" id="redaction-panel">
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6 control-label" style="text-align:left">Speech Transcription
                </label>
                <div class="col-md-6"  align="left">
                  <label class="switch">
                     <input type="checkbox" class="form-control switch" id="speech-transcription-enabled-switch" ${this.defaults.transcription == 1 ? "checked" : ""}>
                    <span data-cy="speech-transcription-enabled-switch"></span>
                  </label>
                </div>
              </div>
              
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">

                <label class="col-md-6" align="left">Redaction
                </label>
                <div class="col-md-6"  align="left">
                  <label class="switch">
                    <input type="checkbox" ${this.defaults.transcription == 0 ? "disabled" : ""} class="form-control switch" id="redaction-enabled-switch" ${this.defaults.redaction == 1 ? "checked" : ""}>
                    <span data-cy="redaction-enabled-switch"></span>
                  </label>
                </div>

              </div>
            </div>               
            `: ``}
           </div>
          

           <div class="col-sm-6 col-xs-12">
            <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="left" role="form">
              <label class="col-md-8 no-gutters" align="left">Texting Enabled<br>
              </label>
              <div class="col-md-4 no-gutters"  align="right">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="texting-switch">
                  <span data-cy="texting-switch"></span>
                </label>
              </div>
            </div>
            <div class="campaign_team hidden">
              <label>Team</label>
              <select name="teams" is="teams-select" class="select-teams form-control"></select>
              <label>Chat Treatment</label>
              <select name="" id="chat_message_tree_id" is="message-treatments-select" class="form-control" domain_id="${this.domain_id}" type="chat"></select>
            </div>
            <div class="${this.defaults.call_recording == 1 ? "" : "hidden"}" id="disclaimer-panel" data-cy="call-disclaimer">
            <div>
              <label>Recording Announcement</label>&nbsp<span>(Please select language):</span>
            </div>
            <div>
              <input type="radio" name="disclaimer-lang" value="1" data-cy="lang-english" ${this.defaults.call_disclaimer == 1 ? "checked" : ""}>
              <label>English</label>
            </div>
            <div>
              <input type="radio" name="disclaimer-lang" value="2" data-cy="lang-spanish" ${this.defaults.call_disclaimer == 2 ? "checked" : ""}>
              <label>Spanish</label>
            </div>
            <div>
              <input type="radio" name="disclaimer-lang" value="3" data-cy="lang-french" ${this.defaults.call_disclaimer == 3 ? "checked" : ""}>
              <label>French</label>
            </div>
            ${this._is_admin ? `<div><input type="radio" name="disclaimer-lang" value="0" data-cy="lang-none" ${this.defaults.call_disclaimer == 0 ? "checked" : ""}> <label>None</label></div>` : ''}
          </div>
           </div>
          </div>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="step-1-next" data-cy="step-1-next">Next</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>
    `;

    
    this.querySelector(".tags-container").appendChild(new TagInput(this.domain_id, [], this.default_tags));

    this.querySelector('#texting-switch').addEventListener('click', function() {
      if(this.querySelector('#texting-switch').checked == false) {
        this.querySelector('.campaign_team').classList.add('hidden');
      } else {
        this.querySelector('.campaign_team').classList.remove('hidden');
      }
    }.bind(this))

    this.campaignNumber();

    this.querySelector('#call-rec-switch').addEventListener('click', function() {
      if(this.querySelector('#call-rec-switch').checked == false) {
        this.querySelector('#disclaimer-panel').classList.add('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.add('hidden');
        }
      } else {
        this.querySelector('#disclaimer-panel').classList.remove('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.remove('hidden');
        }
      }
    }.bind(this))

    if(this._is_admin) {
      this.querySelector('#speech-transcription-enabled-switch').addEventListener('click', function() {
        if(this.querySelector('#speech-transcription-enabled-switch').checked == false) {
          this.querySelector('#redaction-enabled-switch').setAttribute('disabled', true);
        } else {
          this.querySelector('#redaction-enabled-switch').removeAttribute('disabled');
        }
      }.bind(this))
    }

    this.querySelector('#step-1-next').addEventListener('click', function(e) {
      e.preventDefault();
      if(this.validateStep()) {
        this.querySelector('.campaign-buttons').classList.add('hidden');
        this.querySelector('.camp-vertical-arrow').classList.remove('hidden');
        document.querySelector('new-campaign-two').revealStep();
      }
    }.bind(this))
  }
  campaignNumber() {
    let options = [];
    for(let i = 1; i <= 15; i++) {
      options.push(`<option value="${i}">${i}</option>`);
    }
    if(this._is_admin) {
      options.push(`<option value="25">25</option>`); 
      options.push(`<option value="50">50</option>`); 
      options.push(`<option value="75">75</option>`); 
      options.push(`<option value="100">100</option>`); 
      options.push(`<option value="125">125</option>`); 
      options.push(`<option value="150">150</option>`); 
      options.push(`<option value="175">175</option>`); 
      options.push(`<option value="200">200</option>`); 
    }
    this.querySelector('#campaign-count').innerHTML = options.join('');
  }

  validateStep() {
    let isValid = true;
    let errors = "";
    if(!this.querySelector('#campaign-name').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide a campaign name.
                                                </div>`;
      isValid = false;
    } 

    if(this.querySelector('#texting-switch') != null && this.querySelector('#texting-switch').checked == true && this.querySelector("select[name='teams']").value == '') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> A team must manage your incoming text messages.
                                                </div>`;
      isValid = false;
    }

    if(this.querySelector('#lead-score-switch') != null && this.querySelector('#lead-score-switch').checked && !this.querySelector('#call-rec-switch').checked) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Call Recording must be turned on when turning on LeadScore.
                                                </div>`;
      isValid = false;
    }

    // add validation for speech transcription

    if(!this.querySelector("tag-input").validate()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> All Campaign Tags must have a Name selected.
                    </div>`;
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;

    return isValid
  }
}

customElements.define('new-campaign-one', NewCampaignOne)